import { ClientSettings } from "../ClientSettings";
import { GrammarRequest } from "./GrammarRequest";
import { Response } from "./Response";
import { ScoreSettings } from "./ScoreSettings";
import { Text } from "./Text";
import { Author } from "./Author";
import { ClientFeedbackRequest } from "./ClientFeedbackRequest";

export default class GrammarClient {
  constructor(
    readonly author: Author,
    public scoreSettings: ScoreSettings,
    readonly clientSettings: ClientSettings
  ) {}

  public static readonly DEFAULT_ADVICE_LANGUAGE = "ENGLISH";

  public static readonly ADVICE_LANGUAGES = [
    "ENGLISH",
    "SPANISH",
    "FRENCH",
    "GERMAN",
    "TRADITIONAL_CHINESE",
    "SIMPLIFIED_CHINESE",
    "JAPANESE",
    "KOREAN",
  ] as const;

  // readonly route = '/grammar/v1/score';
  readonly scoreRoute = "/proxy/grammar/score";
  async postGrammarScore(text: Text, accessToken: string): Promise<Response> {
    const request: GrammarRequest = {
      ...this.author,
      scoreSettings: this.scoreSettings,
      scoreType: "GRAMMAR",
      metaData: "",
      optIn: true,
      topicId: "testing",
      ...text,
    };
    const response = await fetch(
      this.clientSettings.baseUrl + this.scoreRoute,
      {
        method: "POST",
        headers: GrammarClient.makeHeaders(accessToken),
        body: JSON.stringify(request),
      }
    );
    return response.json();
  }

  readonly clientFeedbackRoute = "/proxy/grammar/feedback";

  async postClientFeedback(
    request: ClientFeedbackRequest,
    accessToken: string
  ): Promise<globalThis.Response> {
    return fetch(this.clientSettings.baseUrl + this.clientFeedbackRoute, {
      method: "POST",
      headers: GrammarClient.makeHeaders(accessToken),
      body: JSON.stringify(request),
    });
  }

  private static makeHeaders(accessToken: string): HeadersInit {
    return {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    };
  }

  public setLanguage(language: AdviceLanguage): void {
    this.scoreSettings.adviceLanguage = language;
  }
}

export type AdviceLanguage = (typeof GrammarClient.ADVICE_LANGUAGES)[number];
